import { InputMask } from "@/components/ui/input-mask";
import { EtapasCompraRapida } from "..";
import { MASCARA_CPF } from "@/utils/Constants";

interface EtapaInserirCPFProps {
    etapa: EtapasCompraRapida,
    formik: any,
    submiting: boolean
}

export function EtapaInserirCPF({ formik, submiting }: EtapaInserirCPFProps) {
    return (
        <>
            <h1 className="text-center text-primary font-semibold">
                Insira seu CPF
            </h1>
            <InputMask
                disabled={submiting}
                type="text"
                id="CPF"
                className="text-center text-primary text-2xl"
                required
                formik={formik}
                name='CPF'
                mask={MASCARA_CPF}
            />
        </>
    )
}